// extracted by mini-css-extract-plugin
export default {"uploadBox":"UploadScreenshotV2_uploadBox__4fv1z","customFileUpload":"UploadScreenshotV2_customFileUpload__ImJZP"};